module.exports = __webpack_public_path__ + "static/media/symbol_delete.25dbe6a5.svg";